import * as types from '../mutation-types'
import shoppingCartRepository from '../../api/shoppingCartRepository'

const state = {
  productsInShoppingCart: [],
  shoppingCartToSave: []
}

const getters = {
  productsInShoppingCart: state => state.productsInShoppingCart,
  shoppingCartToSave: state => state.shoppingCartToSave
}

const actions = {
  saveShoppingCart ({commit}, customerId) {
    commit(types.SET_SHOPPING_CART_TO_SAVE, state.productsInShoppingCart)
    localStorage.setItem('shoppingCart', JSON.stringify(state.productsInShoppingCart))
    if (customerId) {
      return shoppingCartRepository.saveShoppingCart(state.productsInShoppingCart)
    }
  },
  getShoppingCart ({commit}) {
    return shoppingCartRepository.getShoppingCart().then((response) => {
      commit(types.SET_PRODUCTS_IN_SHOPPING_CART, response.data)
    })
  }
}

const mutations = {
  [types.ADD_PRODUCT_TO_SHOPPING_CART] (state, payload) {
    let isUpdated = false

    if (state.productsInShoppingCart) {
      state.productsInShoppingCart.forEach((product, index) => {
        if (product.id === payload.id) {
          state.productsInShoppingCart.splice(index, 1)
          state.productsInShoppingCart.push(payload)
          isUpdated = true
        }
      })
      if (!isUpdated) {
        state.productsInShoppingCart.push(payload)
      }
    } else {
      state.productsInShoppingCart = []
      state.productsInShoppingCart.push(payload)
    }
  },
  [types.ADD_DISCOUNTS_TO_PRODUCTS_IN_SHOPPINGCART] (state, discounts) {
    let products = state.productsInShoppingCart
    state.productsInShoppingCart = []
    products.forEach((product) => {
      let discountApplied = false
      discounts.forEach((discount) => {
        if (product.categoryCode === discount.code) {
          if (discount.active) {
            product.discount = discount.discount
          } else {
            product.discount = 0
          }
          discountApplied = true
          state.productsInShoppingCart.push(product)
        }
      })
      if (!discountApplied) {
        product.discount = 0
        state.productsInShoppingCart.push(product)
      }
    })
  },
  [types.ADD_CUSTOMER_SPECIFIC_PRICES_TO_PRODUCTS_IN_SHOPPINGCART] (state, prices) {
    let products = state.productsInShoppingCart
    state.productsInShoppingCart = []
    products.forEach((product) => {
      let priceApplied = false
      prices.forEach((price) => {
        if (product.articleNumber === price.articleNumber) {
          product.price = price.price
          product.customPrice = true
          product.discount = 0
          priceApplied = true
          state.productsInShoppingCart.push(product)
        }
      })
      if (!priceApplied) {
        state.productsInShoppingCart.push(product)
      }
    })
  },
  [types.EDIT_PRODUCT_IN_SHOPPING_CART] (state, payload) {
    state.productsInShoppingCart.forEach((product, index) => {
      if (product.id === payload.id) {
        state.productsInShoppingCart.splice(index, 1)
        state.productsInShoppingCart.push(payload)
      }
    })
  },
  [types.REMOVE_PRODUCT_FROM_SHOPPING_CART] (state, payload) {
    state.productsInShoppingCart.forEach((product, index) => {
      if (product.id === payload.id) {
        state.productsInShoppingCart.splice(index, 1)
      }
    })
  },
  [types.SET_PRODUCTS_IN_SHOPPING_CART] (state, payload) {
    state.productsInShoppingCart = payload
  },
  [types.SET_SHOPPING_CART_TO_SAVE] (state, payload) {
    state.shoppingCartToSave = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
